import React from "react";
import { Field } from "./Field";
import styled from "styled-components";

const FieldGroup = ({ field, onChange, values, onBlur, errors }: any) => {
    const fields = field.fields;
    const FormGroup = field.wrapper || Wrapper;

    return (
        <FormGroup key={field.id}>
            {fields.map((f: { name: string; id: string | number }) => {
                return (
                    <Field
                        key={f.id}
                        field={f}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={values[f.name]}
                        error={errors[f.name]}
                    />
                );
            })}
        </FormGroup>
    );
};

export default FieldGroup;

const Wrapper = styled("div")`
    margin-bottom: 20px;

    input,
    label {
        display: block;
    }
`;
